import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../auth/api.js';
import { useAuth } from '../auth/context.js';

/**
 * Lands here after the API /auth/callback redirects us with the session
 * token in the URL fragment. We stash it in localStorage, clean the URL,
 * refresh the auth context, and bounce to home.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const token = params.get('token');
    if (!token) {
      navigate('/auth/error?reason=no_token', { replace: true });
      return;
    }
    setToken(token);
    // Clear fragment so token isn't preserved in history
    history.replaceState(null, '', window.location.pathname);
    void refresh().then(() => navigate('/', { replace: true }));
  }, [navigate, refresh]);

  return (
    <main className="grid min-h-screen place-items-center">
      <p className="text-slate-500">กำลังเข้าสู่ระบบ...</p>
    </main>
  );
}
